export default __webpack_public_path__ + "static/media/HARVEY.e42ba462.png";